import request from '@/utils/request'

import { ResponseData, ResponseDataList, Search, CURD, SuggestionSearch } from '../schemas'
import { ResponseDataArray } from '../schemas/data'

export const getList = (data: Search): Promise<ResponseDataList> => {
    return request({
        url: '/scenic-spots/search',
        method: 'post',
        data,
    })
}

export const doAdd = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/scenic-spots',
        method: 'post',
        data,
    })
}

export const doUpdate = (data: CURD): Promise<ResponseData> => {
    return request({
        url: '/scenic-spots',
        method: 'put',
        data,
    })
}

export const doDelete = (data: CURD): Promise<ResponseData> => {
    return request({
        url: `/scenic-spots/${String(data.id)}`,
        method: 'delete',
    })
}

export const getDetail = (id: string): Promise<ResponseData> => {
    return request({
        url: `/scenic-spots/${id}`,
        method: 'get',
    })
}

export const getSuggestions = (data: SuggestionSearch): Promise<ResponseDataArray> => {
    return request({
        url: '/scenic-spots/suggestions',
        method: 'post',
        data
    })
}
